import { defineComponent as _defineComponent } from 'vue'
import {computed} from "vue";
import {ModelErrors} from 'capitalist-shared/src/core/model';


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorMessageBlock',
  props: {
  errors: {
    type: [Object, ModelErrors],
    required: true,
  },
  attribute: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const attributes = computed(() => {
  return props.attribute.split('|');
})

const messages = computed(() => {
  const messages: string[] = [];
  for (const attribute of attributes.value) if (props.errors.has(attribute)) messages.push(props.errors.get(attribute));
  return messages;
})

const hasErrors = computed(() => {
  for (const attribute of attributes.value) if (props.errors.has(attribute)) return true;
  return false;
})

return { __sfc: true,props, attributes, messages, hasErrors, computed, ModelErrors }
}

})